import { render, staticRenderFns } from "./userManagement.vue?vue&type=template&id=c1d510b8&scoped=true&"
import script from "./userManagement.vue?vue&type=script&lang=ts&"
export * from "./userManagement.vue?vue&type=script&lang=ts&"
import style0 from "./userManagement.vue?vue&type=style&index=0&id=c1d510b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d510b8",
  null
  
)

export default component.exports